<div fxLayout="column" [ngStyle]="{'max-height.px': innerHeight}" class="layout-padd">



    <div id="title" fxLayout="column" fxLayoutGap="1px">

        <div fxLayout="row wrap" fxLayoutAlign="start start"  fxLayoutGap="15px" fxLayoutGap.xs="10px" id="chipsProducts">
            <mat-chip-list class=" chip-custom " >

                <div *ngFor="let sugg of suggestions;let index=index" fxLayout="row wrap">

                    <div *ngFor="let value of sugg.products_exist_suggestions_list" >


                        <div *ngFor="let prod of value.products" fxLayout="row">
                            <mat-chip *ngIf="prod.productToAdd && prod.suggestion_id && prod.suggestion_id==sugg.id"
                                style="width: 100px;" class="elipis text-center" (click)="scrolltoprod(prod)">

                                {{prod.display_lang.name}}

                            </mat-chip>

                        </div>


                    </div>





            </div>
            </mat-chip-list>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" fxFlex class="mat-title boldest">

            <div> {{'suggestions.title'|translate}}</div>
        </div>

        <div fxLayoutGap="10px" fxLayout="row" fxLayoutAlign="center center" *ngIf="suggestions&& suggestions.length>1"
            style="font-size: 10px;padding-bottom: 10px;">{{'suggestions.title_2'|translate}}</div>

        <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="15px"
            *ngIf="suggestions&& suggestions.length>1" style="padding-bottom: 15px !important;">

            <div *ngFor="let sugg of suggestions;let index=index">
                <button mat-raised-button class="rounded-button " [ngClass]="{ activeButton: this.isActive==index }"
                    (click)="setButton(index)">
                    {{index+1}}
                </button>

            </div>
        </div>

    </div>


    <div fxLayout="column" class="layout-padd scrolled " fxLayoutGap="20px"
        style="margin-bottom: 70px;" id="#popupCont" [ngStyle]="{'height.px': maxheight}"  >



        <div *ngIf="pointOfsale && !pointOfsale.webshop_display_mode || media.isActive('xs')  " class="full-w"
            >

            <div *ngFor="let sugg of suggestions;let index = index;" class="full-w" id="id_{{index}}">

                <div fxLayout="column" class="layout-padd-credit-due full-w">
                    <div class="boldest" fxLayoutAlign="start center"> {{ sugg.name}}</div>
                    <div class="italic" fxLayoutAlign="start center"> {{ sugg.description}}</div>

                </div>





                <div *ngFor="let value of sugg.products_exist_suggestions_list;let indexrow = index">
                    <div style="margin-top: 5px;margin-bottom:10px">{{value.rubric_name|capitalize}}</div>

                    <div fxLayout="row wrap" fxLayoutGap="0" fxLayout.xs="column" fxLayoutGap.xs="10px">
                        <div *ngFor="let prod of value.products let first = first;let index = index;"
                            fxFlex="{{value.products.length>1?50:100}}" fxFlex.xs=100>

                            <div id="{{'prod_'+prod.id+'_'+prod.suggestion_id}}" *ngIf="index<=5"
                                class="clicked card-padd" fxLayout="row" ngClass.xs="card-padd-xs"
                                style="position: relative;"
                                [class.borderGreen]="prod.productSuggeAdded && prod.productToAdd && prod.suggestion_id&&prod.suggestion_id==sugg.id"
                                (click)="openProdDial(prod,sugg.id)" angulartics2On="click"
                                angularticsAction="openProductDialog" angularticsCategory="products">

                                <!-- Out of stock badge -->
                                <div class="out-of-stock-badge-grid text-align" fxLayoutAlign="center center"
                                    *ngIf="prod.stock && prod.stock.count <= 0">
                                    <span class="boldest mat-caption">{{"unavailable"|translate}} </span>
                                </div>
                                <!-- type menu Badge -->

                                <div *ngIf="prod.product_type==2 && (!prod.stock ||prod.stock && prod.stock.count > 0)"
                                    fxLayoutAlign="center center" class="text-align menu  menu-badge-card-grid "
                                    ngClass.xs="menu-badge-card-pos-list-xs">
                                    <span class="mat-caption boldest">{{'Menu'|translate}}</span>
                                </div>
                                <!-- type option Badge -->
                                <!-- <div *ngIf="prod.product_type==1 && (!prod.stock ||prod.stock && prod.stock.count > 0)"
                                    fxLayoutAlign="center center" class="text-align option  menu-badge-card-grid "
                                    ngClass.xs="menu-badge-card-pos-list-xs">
                                    <span class="mat-caption boldest">{{'Option'|translate}}</span>
                                </div> -->
                                <!-- type new Badge -->
                                <div *ngIf="ProductService.getNewProduct(prod.date)" fxLayoutAlign="center center"
                                    class="text-align new  new-badge-card-grid "
                                    ngClass.xs="new-badge-card-pos-list-xs-suggestion" [class.zindex-1]="prod.stock && prod.stock.count <= 0">
                                    <span class="mat-caption boldest">{{'New'|translate}}</span>
                                </div>
                                <!-- Price period Badge -->
                                <div *ngIf="prod.id_price_period > 0" class="layout-padd-1 secondary clicked promo-badge-grid"
                                    angulartics2On="click" angularticsAction="openPromoShedulesDial"
                                    angularticsCategory="product">
                                    <span class="mat-caption boldest">{{ProductService.getPricePeriodName(prod.id_price_period) | capitalize}}</span>
                                </div>

                                <div fxLayout="row" class="rad-bord"
                                    [class.out-of-stock-prod]="prod.stock && prod.stock.count <= 0"
                                    style="padding: 10px; background: white; border: 1px solid #ddd; overflow: hidden;"
                                    fxFlex>

                                    <div fxLayout="column" fxFlex class="hidden-overflow">

                                        <!-- Nom -->
                                        <div style="padding-bottom: 5px;" fxLayout="row" fxFlex>

                                            <div class="list-title elipis">{{prod.display_lang.name}}</div>
                                        </div>


                                        <div class="truncate-text-2" *ngIf="prod.description">
                                            <p class="list-desc desc-color">{{prod.display_lang.description |
                                                removeHtmlFromString
                                                }}</p>
                                        </div>

                                        <!-- Comble le vide -->
                                        <div fxFlex></div>

                                        <!-- Prix -->

                                        <div style="padding-top: 5px;"
                                            *ngIf="prod.prices[0].price && prod.prices[0].price > 0">
                                            <span
                                                class="list-price">{{prod.prices[0].price|discountVipFilter:merchantClient$:prod
                                                |
                                                priceFilter}}</span>

                                            <!-- <span
class="list-price">{{(prod.productToAdd?prod.productToAdd.quantity*prod.prices[0].price:  prod.prices[0].price)|discountVipFilter:merchantClient$:prod
|
priceFilter}}</span> -->
                                        </div>

                                        <div style="padding-top: 5px;"
                                            *ngIf="prod.productToAdd &&prod.productToAdd.details&&prod.productToAdd.details.length>0">
                                            <div *ngFor="let item of prod.productToAdd.details">
                                                <span class="list-price-option ">
                                                    {{item.display_lang.name|capitalize}}
                                                    <span *ngIf="item.price>0">+
                                                        {{item.price|discountVipFilter:merchantClient$:item|priceFilter}}</span></span>
                                            </div>
                                        </div>

                                        <!-- <div *ngIf="prod.productToAdd && multiple" style="position: absolute; bottom: 10px !important;
    right: 10px !important;">
                                            <div class="v-align-middle" [matBadge]="prod.productToAdd.quantity"
                                                matBadgeColor="primary"> </div>
                                        </div> -->
                                    </div>

                                    <!-- Images -->
                                    <img *ngIf="prod.image.length > 0" src="{{prod.image[1]}}" class="prod-img rad-bord"
                                        ngClass.xs="prod-img-xs">


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>





        <!-- List Type -->
        <div *ngIf="pointOfsale && pointOfsale.webshop_display_mode && !media.isActive('xs')" class="full-w"
            id="#popupCont" [ngStyle]="{'height.px': maxheight}">

            <div *ngFor="let sugg of suggestions ;let index = index;" class="full-w" id="id_{{index}}" class="full-w">

                <div fxLayout="row" fxLayoutGap="10px" class="layout-padd-credit-due full-w">
                    <div class="boldest" fxLayoutAlign="start center"> {{ sugg.name}}</div>
                    <div class="italic" fxLayoutAlign="start center"> {{ sugg.description}}</div>


                </div>





                <div *ngFor="let value of sugg.products_exist_suggestions_list">
                    <div>{{value.rubric_name|capitalize}}</div>
                    <div fxLayout="row wrap">

                        <div *ngFor="let prod of value.products let first = first; let index =index;" fxFlex="33"
                            fxFlex.xl=25 fxFlex.xs=100>


                            <!-- <div *ngFor="let prod of sugg.products_exist_suggestions; let first = first; let index =index;" -->
                            <!-- fxFlex="33" fxFlex.xl=25 fxFlex.xs=100> -->
                            <div id="{{'prod_'+prod.id+'_'+prod.suggestion_id}}" *ngIf="index<=5" class="clicked"
                                style="height: 300px; position: relative; padding: 10px;"
                                (click)="openProdDial(prod,sugg.id)" angulartics2On="click"
                                angularticsAction="openProductDialog" angularticsCategory="products">


                                <div fxLayout="column" fxLayoutGap="5px" class="rad-bord whited"
                                    style="border: 1px solid #ddd;  position: relative; overflow: hidden;"
                                    [class.borderGreen]="prod.productSuggeAdded && prod.productToAdd && prod.suggestion_id&&prod.suggestion_id==sugg.id"
                                    fxFlex>
                                    <!-- Out of stock badge -->
                                    <div class="out-of-stock-badge-card full-w text-align" fxLayoutAlign="center center"
                                        *ngIf="prod.stock && prod.stock.count <= 0">
                                        <span class="mat-caption boldest">{{"unavailable"|translate}}</span>
                                    </div>
                                    <!-- type menu Badge -->

                                    <div *ngIf="prod.product_type==2 && (!prod.stock ||prod.stock && prod.stock.count > 0)"
                                        fxLayoutAlign="center center" class="text-align menu  menu-badge-card">
                                        <span class="mat-caption boldest">{{'Menu'|translate}}</span>
                                    </div>
                                    <!-- type option Badge -->
                                    <!-- <div *ngIf="prod.product_type==1 && (!prod.stock ||prod.stock && prod.stock.count > 0)"
                                        fxLayoutAlign="center center" class="text-align option  menu-badge-card">
                                        <span class="mat-caption boldest">{{'Option'|translate}}</span>
                                    </div> -->
                                    <!-- type new Badge -->
                                    <div *ngIf="ProductService.getNewProduct(prod.date) " fxLayoutAlign="center center"
                                        class="text-align new  new-badge-card-list " [class.zindex-1]="prod.stock && prod.stock.count <= 0">
                                        <span class="mat-caption boldest">{{'New'|translate}}</span>
                                    </div>
                                    <!-- Price period Badge -->
                                    <div *ngIf="prod.id_price_period > 0"
                                        class="layout-padd-1 rad-bord secondary clicked promo-badge-card">
                                        <span class="mat-caption boldest">{{ProductService.getPricePeriodName(prod.id_price_period) | capitalize}}</span>
                                    </div>

                                    <div class="pos-img-cont rad-bord"
                                        [class.out-of-stock-prod]="prod.stock && prod.stock.count <= 0" fxFlex="80"
                                        [ngStyle]="{'background-image': 'url(' + ( prod.image.length > 0 ? prod.image[2] : default_prod) + ')'}">
                                    </div>
                                    <div fxLayout="column" fxLayoutGap="5px" fxLayoutAlign="center center"
                                        style="padding:10px;" fxFlex>
                                        <!-- Nom -->
                                        <div style="padding-bottom: 5px;" fxLayout="row" class="full-w">

                                            <div class="list-title elipis">{{prod.display_lang.name}}</div>
                                        </div>
                                        <span class="list-price"
                                            *ngIf="prod.prices[0].price && prod.prices[0].price > 0">{{prod.prices[0].price
                                            | discountVipFilter:merchantClient$:prod | priceFilter}}</span>
                                        <div fxFlex
                                            *ngIf="!prod.prices[0].price || prod.prices[0].price &&  prod.prices[0].price === 0">
                                        </div>
                                        <div style="padding-top: 5px;"
                                            *ngIf="prod.productToAdd &&prod.productToAdd.details&&prod.productToAdd.details.length>0">
                                            <div *ngFor="let item of prod.productToAdd.details">
                                                <span class="list-price-option ">
                                                    {{item.display_lang.name|capitalize}}
                                                    <span *ngIf="item.price>0">+
                                                        {{item.price|discountVipFilter:merchantClient$:item|priceFilter}}</span></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


        </div>



        <div fxLayout="row" *ngIf="buttonScroll" style="position:absolute; bottom:60px;right: 5px;">
            <div fxLayoutAlign="end start" fxFlex>
                <button mat-icon-button (click)="scroll()" style="z-index: 2;">
                    <mat-icon>arrow_drop_down_circle</mat-icon>
                </button>

            </div>
        </div>
        <div *ngIf="buttonScroll" id='buttonScroll'></div>

        <!--  btn bottom -->








    </div>

    <div class="layout-padd positionBottom" fxLayoutAlign="space-between" fxLayoutGap="10px" id="buttonB">
        <button mat-stroked-button fxFlex="50" (click)="closeDial()">{{"button.cancel" |
            translate}}</button>
        <button mat-stroked-button fxFlex="50" color="primary" [disabled]="!ButtonVisibleAddinBasket"
            (click)="validProductsSuggested()">{{"button.validate" | translate}} </button>
    </div>

    <app-popup-loader [flagLoading]="loaderpop" [size]="30" [statusMessage]="statusMessage">
    </app-popup-loader>
</div>
